var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useContext, useEffect, useState, } from "react";
import CommonLtpRenderer from "src/components/ltp-renderer/common-ltp-renderer";
import { TAB_CHANGE_REFRESH_TIME } from "src/utils/constant";
import { ThemeContext } from "../../../contexts/theme-context";
import { useAppSelector } from "../../../hooks/redux";
import { getEnvironmentVariableOrEmpty } from "../../../utils/methods";
import { unsubscribeDataBySubscriber } from "../../../utils/websocketwrapper";
import styles from "./vix.module.scss";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
const { REACT_APP_URL_CHART } = process.env;
// ref forwarding needed here
// For understanding - https://github.com/react-grid-layout/react-grid-layout/issues/1241#issuecomment-859651584
const scripCode = 999920019;
const { REACT_APP_URL_CHART_INDIA_VIX, REACT_APP_ENV } = process.env;
const componentName = "Vix";
const Vix = React.forwardRef((_a, ref) => {
    var others = __rest(_a, []);
    const [counter, setCounter] = useState(0);
    // const openFeedWs = useAppSelector((state) => state.openFeedWs.socket);
    const { theme } = useContext(ThemeContext);
    const blurTime = useAppSelector((state) => state.app.windowBlurTime);
    const [chartTypeData, setChartTypeData] = useState("Area");
    const url = `${getEnvironmentVariableOrEmpty(REACT_APP_URL_CHART_INDIA_VIX)}/LWDerivative/index.html?type=overview&period=1d&exchange=nse&exchType=D&range=d&symbol=indiavix&scripCode=999920019&appName=5Paisa&appVer=5.11.6.0&osName=Windows&loginId=${getDataFromSession(SESSION_KEYS.CLIENT_CODE)}&theme=${theme}&source=derivative&chartType=${chartTypeData}&counter=${counter}`;
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    // function changeOfChart(url: string) {
    //   if (
    //     url.includes("&chartType=candle") ||
    //     url.includes("&chartType=Candle")
    //   ) {
    //     setChartTypeData("Area");
    //   } else {
    //     setChartTypeData("Candle");
    //   }
    // }
    useEffect(() => {
        if (blurTime >= TAB_CHANGE_REFRESH_TIME) {
            setCounter(counter + 1);
        }
    }, [blurTime]);
    //unmount effect
    useEffect(() => {
        return () => {
            //unmount call here
            unsubscribeDataBySubscriber(componentName);
        };
    }, []);
    const commonLtpRenderCallBack = useCallback((ltp, prevClose, changePercentObj) => {
        return (_jsx("div", Object.assign({ className: styles.priceView }, { children: _jsxs("div", { children: [_jsx("span", Object.assign({ className: "mediumWeight large" }, { children: ltp })), _jsxs("div", Object.assign({ className: `${changePercentObj.isNegative
                            ? styles.negativeColor
                            : styles.positiveColor} ms-2` }, { children: [_jsxs("span", Object.assign({ className: "mediumWeight large me-2" }, { children: [changePercentObj.differenceValue, "(", changePercentObj.differencePercentage, ")"] })), _jsx("span", { className: `${changePercentObj.isNegative
                                    ? styles.redArrow
                                    : styles.greenArrow}` })] }))] }) })));
    }, []);
    return (
    // <Profiler id={"Vix"} onRender={onRenderCallback}>
    _jsx("div", Object.assign({ ref: ref }, others, { children: _jsxs("div", Object.assign({ className: `${styles.fiiContainer}` }, { children: [_jsxs("div", Object.assign({ className: styles.sectionHeader }, { children: [_jsx("span", Object.assign({ className: `${styles.sectionTitle} mediumWeight` }, { children: "INDIA VIX" })), _jsx("div", { className: styles.actionMenu })] })), _jsxs("div", Object.assign({ className: styles.sectionContent }, { children: [_jsx("div", Object.assign({ className: styles.infoPanel }, { children: _jsx(CommonLtpRenderer, { scripCode: scripCode, exch: "N", exchType: "D", renderElement: commonLtpRenderCallBack, componentName: componentName }) })), _jsx("iframe", { loading: "lazy", src: url, width: "100%", 
                            // sandbox="allow-forms allow-popups allow-scripts"
                            height: 180, title: "India vix" })] }))] })) }))
    // </Profiler>
    );
});
Vix.displayName = "Vix";
export default Vix;
